import React from 'react'
import Navbar from '../header/Navbar'
import Footer from '../footer/Footer'
import SalaryCalculator from '../games/other/SalaryCalculator'

const SalaryDetails = () => {
  return (
    <div>
      <Navbar/>
      <SalaryCalculator/>
      <Footer/>
    </div>
  )
}

export default SalaryDetails
